// Entity identifiers are GUIDs as of the ConvertIdsToGuid migration. They are
// opaque strings on the client — never coerce them with Number().

export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

const GUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Bumped whenever persisted client state becomes incompatible.
 * 2 = entity ids are GUIDs (previously auto-increment integers).
 */
export const STORAGE_SCHEMA_VERSION = 2;
export const STORAGE_VERSION_KEY = 'hz_storage_version';

/** Normalizes any id-ish value to a trimmed string. Missing values become ''. */
export function toIdString(value) {
  if (value === null || value === undefined) return '';
  return String(value).trim();
}

/** True when the value is shaped like a GUID, ignoring whether it is the empty one. */
export function isGuid(value) {
  return GUID_PATTERN.test(toIdString(value));
}

/**
 * True when the value is a usable entity id.
 *
 * Rejects two distinct classes of bad input:
 *  - EMPTY_GUID, which the migration wrote into rows it could not map, so it
 *    means "unknown" and must not be sent as a real reference.
 *  - Anything that is not GUID-shaped — notably the auto-increment integers left
 *    behind in carts, zone selections, and tokens issued before the migration.
 *    Those would otherwise be posted to an API that expects a Guid.
 */
export function isValidId(value) {
  const id = toIdString(value);
  if (!isGuid(id)) return false;
  return id.toLowerCase() !== EMPTY_GUID;
}

/**
 * True when persisted state written under `storedVersion` predates the current
 * schema and must be discarded rather than sent to the API.
 */
export function isStorageStale(storedVersion) {
  const parsed = Number(storedVersion);
  return !Number.isFinite(parsed) || parsed < STORAGE_SCHEMA_VERSION;
}
